import moment from "moment";

export function getDaysInMonth(year, monthIndex) {
  const daysInMonth = moment({ year, month: monthIndex }).daysInMonth();

  return Array.from({ length: daysInMonth }, (_, i) => {
    return moment({ year, month: monthIndex, day: i + 1 }).format("DD/MM/YYYY");
  });
}

export const generateGroupHeaders = (services) => {
  console.log(services);
  
  const headers = [
    {
      label: "Tanggal",
      colSpan: 1,
      rowSpan: 2,
      style: { verticalAlign: "middle" },
    },
  ];

  services.forEach((item) => {
    headers.push({
      label: item.serviceCategoryName,
      colSpan: 2,
    });
  });

  return headers;
};

export const generateTableColumns = (services) => {
  const columns = [
    {
      key: "tanggal",
      label: "",
      headerStyle: { display: "none" },
    },
  ];

  services.forEach((item) => {
    const key = item.serviceCategory; 

    columns.push(
      {
        key: `${key}_daily`,
        label: "Harian",
      },
      {
        key: `${key}_acc`,
        label: "Akumulasi",
      }
    );
  });

  return columns;
};

export const buildExcelRequestBodyPendapatan = ({
  year,
  dataTable = [],
  rawData = [],
}) => {
  const serviceHeaders = rawData.map((item) => ({
    title: item.serviceCategoryName,
    children: [
      {
        key: `${item.serviceCategory}_daily`,
        title: "Harian",
      },
      {
        key: `${item.serviceCategory}_acc`,
        title: "Akumulasi",
      },
    ],
  }));

  const sortedData = [...dataTable].sort(
    (a, b) => Number(a.tanggal.slice(0, 2)) - Number(b.tanggal.slice(0, 2))
  );

  return {
    filename: `${year}_Laporan_Pendapatan_Job_Harian`,
    sheets: [
      {
        name: "Report",
        headers: [
          {
            key: "tanggal",
            title: "Tanggal",
          },
          ...serviceHeaders,
        ],
        data: sortedData,
      },
    ],
  };
};

